export default __webpack_public_path__ + "static/media/hhync-sgl-white.89884e29.svg";